import * as React from "react";

export const useMountEffect = (effect: React.EffectCallback) => {
	const [isMounted, setIsMounted] = React.useState(false);

	React.useEffect(() => {
		if (!isMounted) {
			setIsMounted(true);
			return effect();
		}
	}, [isMounted, effect]);
};
